import { render, staticRenderFns } from "./UploadResult.vue?vue&type=template&id=7c881aa7&"
import script from "./UploadResult.vue?vue&type=script&lang=js&"
export * from "./UploadResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports